"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProductDisallowed = void 0;
// this file exists because shopify's JSON only has :available,
// yet their API only has :inventory_quantity
exports.default = (function (variant) {
    // inventory tracking has been turned off entirely
    if (variant.inventory_management === null)
        return true;
    // otherwise if we know the quantity, respect it
    if (variant.inventory_quantity !== undefined)
        return variant.inventory_quantity > 0;
    // otherwise if we know the boolean availibility, use that
    if (variant.available !== undefined)
        return variant.available;
    // otherwise who knows but let's default to false
    return false;
});
// certain products can be tagged to not be allowed to be selected in the bundler
// e.g., we want to hold inventory to support existing bundles, but not allow new ones
var isProductDisallowed = function (product) { return product.tags.includes('Bundler App Disallow'); };
exports.isProductDisallowed = isProductDisallowed;
